module.exports = __webpack_public_path__ + "static/bs-logo-w-7372614084278bea4f993c37ba70c659.svg";